import { createAsyncThunk } from '@reduxjs/toolkit';
import { GROUP_NAME, ThunkApi, User } from '@greenkub-fronts/shared/interface';

type LoginRequest = {
  email: string;
  password: string;
};

type LoginResponse = {
  email: string;
  token: string;
  profile: User;
};

export const login = createAsyncThunk<LoginResponse, LoginRequest, ThunkApi>(
  'login',
  async (data, { dispatch, extra }) => {
    const resp = await dispatch(
      extra.apiSlice.endpoints.getToken.initiate(
        {
          username: data.email,
          password: data.password,
        },
        { forceRefetch: true }
      )
    );

    const profileResp = await dispatch(
      extra.apiSlice.endpoints.getProfile.initiate(
        {
          token: resp.data.token,
          groupName: GROUP_NAME.PROFILE,
        },
        { forceRefetch: true }
      )
    );

    localStorage.setItem(
      'auth',
      JSON.stringify({
        email: data.email,
        token: resp.data.token,
        user: profileResp.data,
      })
    );

    //  @ts-ignore
    window.dataLayer = window.dataLayer || [];
    //  @ts-ignore
    window.dataLayer.push({
      'event': 'new_subscriber',
      'email': data.email,
      'userID': profileResp.data.id,
      'role': profileResp.data.roles.join(",")
    });

    return {
      email: data.email,
      token: resp.data.token,
      profile: profileResp.data,
    } as LoginResponse;
  }
);
